import { Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { ChatWidget } from './components/ChatWidget';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { PricingPage } from './pages/PricingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { FAQViewerPage } from './pages/FAQViewerPage';

function App() {
  return (
    <BrandingProvider>
      <LanguageProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/faq" element={<FAQViewerPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ChatWidget />
          </SubscriptionProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrandingProvider>
  );
}

export default App;
